module.exports = __webpack_public_path__ + "static/img/5.8d0c318.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/5.png
// module id = oq2s
// module chunks = 0